import { render, staticRenderFns } from "./ym-quota.vue?vue&type=template&id=1c62f3b7&scoped=true&"
import script from "./ym-quota.vue?vue&type=script&lang=js&"
export * from "./ym-quota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c62f3b7",
  null
  
)

export default component.exports